import { useHistory } from "react-router-dom";
import { Icon, Feedback } from "@sicredi/react";
import { PAGE } from "#/constants";

export default function NotFound() {
  const history = useHistory();

  return (
    <Feedback
      icon={
        <Icon name="satisfaction-dissatisfied" aria-hidden="true" size={104} />
      }
      title="Página não encontrada"
      secondaryButton={{
        onClick: () => history.push(PAGE.ROOT()),
        children: "Voltar para o início",
      }}
    >
      Essa página não existe.
    </Feedback>
  );
}
